export function indexBy<T>(items: T[], keyFunc: (item: T) => string): Map<string, T> {
    const map = new Map<string, T>();
    for (const item of items) {
        const key = keyFunc(item);
        map.set(key, item);
    }
    return map;
}
